<!-- 最左边的选择框 -->
<template>
  <div class="mycard">
    <header>
      <div class="avatar"></div>
    </header>
    <div class="navbar" @click="clearSearch">
      <router-link :to="authObj ? `/chat?${authObj}` : '/chat'" class="icon iconfont icon-msg"></router-link>
    </div>
    <footer>
      <div class="polling-status" :class="{ 'disconnected': !isPolling, 'connected': isPolling }" @click="handlePollingClick">
        <span class="status-dot"></span>
        <span class="status-text">{{ isPolling ? '连接中' : '已断开' }}</span>
      </div>
    </footer>
  </div>
</template>

<script>
import { getRequestParams, decodeFromBase64 } from '@/utils/getPrams.js'
import { MessageBox } from 'element-ui'

export default {
  data() {
    return {
      authObj: null,
      isPolling: true, // 默认轮询状态为true
      pollingStatusInterval: null
    }
  },
  created() {
    const urlParams = getRequestParams();
    //console.log('mycard.vue - URL参数:', urlParams);
    if (urlParams) {
      // 使用浏览器兼容的Base64解码方式
      try {
        // 先解码URL编码的参数，然后再进行Base64解码
         this.authObj = decodeURIComponent(urlParams);
        
        //console.log('mycard.vue - authObj:', this.authObj);

      
      } catch (error) {
        console.error('解析URL参数错误:', error);
        // 解析错误，跳转到登录页面
        this.$router.push({
          path: '/login'
        });
      }
    }
  },
  mounted() {
    // 启动轮询状态检查
    this.startPollingStatusCheck();
  },
  beforeDestroy() {
    // 停止轮询状态检查
    this.stopPollingStatusCheck();
  },
  methods: {
    // 启动轮询状态检查
    startPollingStatusCheck() {
      // 清除之前的定时器
      this.stopPollingStatusCheck();
      // 每秒检查一次轮询状态
      this.pollingStatusInterval = setInterval(() => {
        this.checkPollingStatus();
      }, 1000);
    },
    // 停止轮询状态检查
    stopPollingStatusCheck() {
      if (this.pollingStatusInterval) {
        clearInterval(this.pollingStatusInterval);
        this.pollingStatusInterval = null;
      }
    },
    // 检查轮询状态
    checkPollingStatus() {
      // 通过父组件访问message组件的轮询状态
      try {
        if (this.$parent && this.$parent.$refs && this.$parent.$refs.message) {
          const messageComponent = this.$parent.$refs.message;
          // 检查message组件的messagePollingInterval是否存在
          this.isPolling = !!messageComponent.messagePollingInterval;
          //console.log('轮询状态检查:', this.isPolling);
        } else {
          // 如果无法访问到message组件，保持当前状态
          //console.log('无法访问到message组件');
        }
      } catch (error) {
        console.error('检查轮询状态时出错:', error);
        // 出错时保持当前状态
      }
    },
    loadUser() {
     


    },
    clearSearch() {
      // 通知父组件清除搜索
      this.$parent.$emit('search-change', '')
    },
    // 点击轮询状态指示器的处理方法
    handlePollingClick() {
      // 只有在断开状态下点击才会弹出确认框
      if (!this.isPolling) {
        MessageBox.confirm('是否重新连接？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
          closeOnClickModal: false // 点击空白处不关闭弹窗
        }).then(() => {
          // 用户点击确定，通过父组件直接重新开始轮询
          if (this.$parent) {
            this.$parent.resumeAllPolling();
          }
        }).catch(() => {
          // 用户点击取消，保持轮询断开状态
          //console.log('用户取消了继续轮询');
        });
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/fonts/iconfont.css';

.mycard {
    position: relative;
    width: 60px;
    height: 610px;
    background-color: rgba(35, 42, 53, 0.8);

  .avatar {
    width: 36px;
    height: 36px;
    margin: 20px 12px 0 12px;
    border-radius: 2px;
    background-image: url('/images/bot.png');
    background-size: cover;
    background-position: center;
  }

  .navbar {
    width: 100%;
    text-align: center;

    a {
      text-decoration: none;
    }

    .icon {
      display: inline-block;
      font-size: 26px;
      margin-top: 28px;
      padding: 0 16px;
      box-sizing: border-box;
      color: rgb(173, 174, 175);
      opacity: 0.8;
      cursor: pointer;
      line-height: 1;
      vertical-align: middle;
      text-decoration: none;

      &.active {
        color: rgb(0, 220, 65);
      }

      &:hover {
        opacity: 1;
      }
    }

    .icon-msg,
    .icon-more {
      font-size: 22px;
      display: block;
      width: 100%;
      padding: 0;
      line-height: 1;
      text-decoration: none;
    }
    
    /* 确保router-link没有下划线 */
    .icon.iconfont {
      text-decoration: none !important;
    }

    .icon-msg {
      margin-top: 28px;
    }
  }

  footer {
    position: absolute;
    bottom: 20px;
    width: 100%;
    text-align: center;
  }

  .polling-status {
    display: block;
    text-align: center;
    cursor: pointer;
    padding: 5px 2px;
    border-radius: 20px;
    transition: all 0.3s ease;
    width: 100%;
    box-sizing: border-box;
  }

  .status-dot {
    display: block;
    margin: 0 auto 5px auto;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    transition: all 0.3s ease;
    background-color: #ccc; /* 默认灰色 */
  }

  .status-text {
    display: block;
    font-size: 12px;
    white-space: nowrap;
    transition: all 0.3s ease;
  }

  .connected .status-dot {
    background-color: #4CAF50;
    box-shadow: 0 0 10px #4CAF50;
  }

  .connected .status-text {
    color: #4CAF50;
  }

  .disconnected .status-dot {
    background-color: #F44336;
    box-shadow: 0 0 10px #F44336;
  }

  .disconnected .status-text {
    color: #F44336;
  }

  /* 默认状态下的文本颜色 */
  .status-text {
    color: #ccc;
  }

  .polling-status:hover {
    transform: scale(1.1);
  }
}
</style>
